"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Artboard",
    fill: props.fill
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-8",
    x: "0",
    y: "23",
    width: "1",
    height: "2"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-8",
    x: "0",
    y: "0",
    width: "1",
    height: "2"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "3",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "5",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "7",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "9",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "11",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "13",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "15",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "17",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "19",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "0",
    y: "21",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-8",
    x: "24",
    y: "23",
    width: "1",
    height: "2"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-8",
    x: "24",
    y: "0",
    width: "1",
    height: "2"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "3",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "5",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "7",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "9",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "11",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "13",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "15",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "17",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "19",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-25",
    x: "24",
    y: "21",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "2 1 2 0 3 0 3 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "4 1 4 0 5 0 5 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "6 1 6 0 7 0 7 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "8 1 8 0 9 0 9 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "10 1 10 0 11 0 11 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "12 1 12 0 13 0 13 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "14 1 14 0 15 0 15 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "16 1 16 0 17 0 17 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "18 1 18 0 19 0 19 1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "20 1 20 0 21 0 21 1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-26",
    x: "22",
    y: "0",
    width: "1",
    height: "1"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "2 25 2 24 3 24 3 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "4 25 4 24 5 24 5 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "6 25 6 24 7 24 7 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "8 25 8 24 9 24 9 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "10 25 10 24 11 24 11 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "12 25 12 24 13 24 13 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "14 25 14 24 15 24 15 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "16 25 16 24 17 24 17 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "18 25 18 24 19 24 19 25"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Rectangle-25",
    points: "20 25 20 24 21 24 21 25"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-26",
    x: "22",
    y: "24",
    width: "1",
    height: "1"
  }))));
};

exports["default"] = _default;